import { createFileRoute, redirect } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ProductNotEnrolledPage = lazy(
  () => import('~/features/onboarding/pages/product-not-enrolled-page'),
);

const searchSchema = z.object({
  product: z.enum(['google', 'meta']).optional(),
});

/**
 * Fallback page shown when a user tries to access a route for a platform they
 * are not enrolled in. Only reachable via a redirect from requireContract —
 * direct navigation without a `product` search param is redirected to `/`.
 */
export const Route = createFileRoute('/_authenticated/_tenant/product-not-enrolled')({
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    if (!search.product) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/' });
    }
  },
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ProductNotEnrolledPage />
    </Suspense>
  ),
});
